

import React from "react";
import './GoalReportPage.css';

const ReportTabSelector = ({ activeTab, onTabChange }) => {
  const getSelfAssessmentIcon = isActive => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 20 20" fill="none">
      <path d="M9.58333 12.5H5.83333C4.94928 12.5 4.10143 12.8512 3.47631 13.4763C2.85119 14.1014 2.5 14.9493 2.5 15.8333V17.5"
        stroke={isActive ? "#3B5998" : "#707070"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.8148 13.8548C18.1468 13.5228 18.3333 13.0726 18.3333 12.6031C18.3333 12.1337 18.1468 11.6834 17.8148 11.3515C17.4829 11.0195 17.0326 10.833 16.5632 10.833C16.0937 10.833 15.6434 11.0195 15.3115 11.3515L11.9698 14.6948C11.7717 14.8928 11.6267 15.1376 11.5482 15.4065L10.8507 17.7981C10.8297 17.8698 10.8285 17.9458 10.847 18.0182C10.8656 18.0906 10.9032 18.1566 10.956 18.2094C11.0088 18.2622 11.0749 18.2999 11.1472 18.3184C11.2196 18.337 11.2956 18.3357 11.3673 18.3148L13.759 17.6173C14.0279 17.5388 14.2726 17.3938 14.4707 17.1956L17.8148 13.8548Z"
        stroke={isActive ? "#3B5998" : "#707070"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.33333 9.16667C10.1743 9.16667 11.6667 7.67428 11.6667 5.83333C11.6667 3.99238 10.1743 2.5 8.33333 2.5C6.49238 2.5 5 3.99238 5 5.83333C5 7.67428 6.49238 9.16667 8.33333 9.16667Z"
        stroke={isActive ? "#3B5998" : "#707070"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const getOverviewIcon = (isActive) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        d="M17.2346 8.98081C17.6772 8.98081 18.0405 8.6208 17.9964 8.18061C17.8115 6.3398 16.9958 4.61955 15.6874 3.31149C14.3791 2.00344 12.6586 1.18808 10.8178 1.00363C10.3768 0.959535 10.0176 1.32275 10.0176 1.76535V8.17981C10.0176 8.39246 10.1021 8.5964 10.2524 8.74677C10.4028 8.89714 10.6067 8.98162 10.8194 8.98162L17.2346 8.98081Z"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.403 13.1C15.8929 14.3063 15.0951 15.3693 14.0793 16.196C13.0635 17.0228 11.8606 17.5881 10.5759 17.8425C9.29109 18.097 7.96356 18.0329 6.70931 17.6557C5.45506 17.2786 4.31229 16.6 3.3809 15.6792C2.44952 14.7583 1.75788 13.6234 1.36646 12.3735C0.975031 11.1237 0.895737 9.79696 1.13551 8.50938C1.37528 7.2218 1.92681 6.01255 2.74189 4.98736C3.55696 3.96217 4.61077 3.15225 5.81117 2.62842"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const getReportIcon = (isActive) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="12" viewBox="0 0 21 12" fill="none">
      <path
        d="M20 1L11.925 9.5L7.17499 4.5L1 11"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3 1H20V7"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  

  const getTeamMemberIcon = (isActive) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none">
      <path
        d="M13.3636 14.9091V13.3636C13.3636 12.5439 13.038 11.7577 12.4583 11.178C11.8787 10.5984 11.0925 10.2727 10.2727 10.2727H4.09091C3.27115 10.2727 2.48496 10.5984 1.90531 11.178C1.32565 11.7577 1 12.5439 1 13.3636V14.9091"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.18173 7.18182C8.88879 7.18182 10.2726 5.79797 10.2726 4.09091C10.2726 2.38385 8.88879 1 7.18173 1C5.47467 1 4.09082 2.38385 4.09082 4.09091C4.09082 5.79797 5.47467 7.18182 7.18173 7.18182Z"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0001 14.909V13.3635C17.9996 12.6787 17.7716 12.0134 17.352 11.4721C16.9324 10.9308 16.345 10.5443 15.6819 10.373"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5908 1.10034C13.2557 1.27057 13.845 1.65725 14.2658 2.1994C14.6866 2.74155 14.9151 3.40835 14.9151 4.09466C14.9151 4.78098 14.6866 5.44777 14.2658 5.98992C13.845 6.53208 13.2557 6.91875 12.5908 7.08898"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  
  const getStackIcon = (isActive) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        d="M10.1979 1.1533C9.97659 1.05228 9.7362 1 9.49297 1C9.24974 1 9.00935 1.05228 8.78805 1.1533L1.50957 4.4683C1.35887 4.53481 1.23073 4.64374 1.14078 4.78183C1.05082 4.91992 1.00293 5.08121 1.00293 5.24605C1.00293 5.4109 1.05082 5.57219 1.14078 5.71028C1.23073 5.84836 1.35887 5.9573 1.50957 6.0238L8.79655 9.3473C9.01784 9.44833 9.25823 9.50061 9.50146 9.50061C9.74469 9.50061 9.98509 9.44833 10.2064 9.3473L17.4934 6.0323C17.6441 5.9658 17.7722 5.85686 17.8622 5.71878C17.9521 5.58069 18 5.4194 18 5.25455C18 5.08971 17.9521 4.92842 17.8622 4.79033C17.7722 4.65224 17.6441 4.54331 17.4934 4.4768L10.1979 1.1533Z"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 9.50024C0.999601 9.66282 1.04579 9.8221 1.1331 9.9592C1.22041 10.0963 1.34517 10.2055 1.4926 10.2737L8.79655 13.5972C9.01669 13.697 9.25557 13.7486 9.49722 13.7486C9.73888 13.7486 9.97776 13.697 10.1979 13.5972L17.4849 10.2822C17.6352 10.2146 17.7626 10.1047 17.8516 9.96582C17.9406 9.82696 17.9873 9.6652 17.986 9.50024"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 13.7502C0.999601 13.9128 1.04579 14.0721 1.1331 14.2092C1.22041 14.3463 1.34517 14.4555 1.4926 14.5237L8.79655 17.8472C9.01669 17.947 9.25557 17.9986 9.49722 17.9986C9.73888 17.9986 9.97776 17.947 10.1979 17.8472L17.4849 14.5322C17.6352 14.4646 17.7626 14.3547 17.8516 14.2158C17.9406 14.077 17.9873 13.9152 17.986 13.7502"
        stroke={isActive ? "#3B5998" : "#707070"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  
  

  const tabs = [
    { key: "overview", label: "Overview", icon: getOverviewIcon },
    { key: "trends", label: "Trends", icon: getReportIcon },
    // { key: "employees", label: "Employees", icon: getTeamMemberIcon },
    // { key: "teams", label: "Teams", icon: getStackIcon }
  ];

  return (
    <div
      style={{
        display: "flex",
        gap: "28px",
        borderBottom: "1px solid #ddd",
        paddingBottom: "-4px",
        marginBottom: "20px",
        
      }}
    >
      {tabs.map(tab => {
        const isActive = activeTab == tab.key;
        return (
          <div
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            style={{
              cursor: "pointer",
              color: isActive ? "#3B5998" : "#4D4D4D",
              borderBottom: isActive ? "3px solid #3B5998" : "3px solid transparent",
              paddingBottom: "6px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.3s ease",
              paddingLeft: "10px",
              paddingRight: "10px"
            }}
          >
            {tab.icon(isActive)}
            <span className="report-tab-text" >{tab.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ReportTabSelector;
